import React from 'react';
import FilterSelectOption from "../../microComponents/tablePages/filter/FilterSelectOption";
import DebouncingInputFilter from "../../microComponents/tablePages/filter/DebouncingInputFilter";
import {allowLoadJson, oldestArray} from "../../helper/jsons/activatedJson";
import DateFilter from "../../microComponents/tablePages/filter/DateFilter";
import FilterProductList from "./topMapFilter/FilterProductList";
import FilterDetails from "./topMapFilter/FilterDetails";
import FilterProductLine from "./topMapFilter/FilterProductLine";
import FilterPalletStatus from "./topMapFilter/FilterPalletStatus";
import FilterQcStatus from "./topMapFilter/FilterQcStatus";
import FilterRows from "./topMapFilter/FilterRows";
import CheckboxFilter from "../../microComponents/tablePages/filter/CheckboxFilter";


const TopSearchMap = ({selectedLocation}) => {


    return (<div className='grid grid-cols-1 2xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4   gap-x-4  gap-y-5 mt-10   '>

        <DebouncingInputFilter data={{placeholder: 'شماره اموال', filterName: 'palletId',}}/>
        <FilterDetails/>
        <FilterProductList/>
        <FilterPalletStatus/>
        <DebouncingInputFilter data={{placeholder: 'قیمت', filterName: 'consumerPriceRials',}}/>
        <FilterQcStatus/>
        <FilterRows selectedLocation={selectedLocation}/>
        <FilterSelectOption data={{
            placeholder: 'جا بجایی', filterName: 'allowLoad',
            mode: 'single',
            options: allowLoadJson,

        }}/>


    </div>);
};

export default TopSearchMap;
